<template>
  <tbody class="thead">
    <tr>
      <th class="sticky-cell">
        {{ walker.sub_label }}
      </th>

      <template v-if="sumDateRanges">
        <th>Total</th>
      </template>
      <template v-else>
        <th>Invoice</th>
        <th>Status</th>
        <th>Invoice total</th>
      </template>

      <th>Paid</th>
      <th>Amount due</th>
    </tr>
  </tbody>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'InvoicesReportTableHeader',
  props: {
    isClient: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    ...mapGetters(['walker', 'sumDateRanges']),
  },
};
</script>
